import './textblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {WysiwygType} from 'types'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'
import {Theme} from 'views/theme'

const styles = style('textblock')

export type TextBlockType = {
	text: WysiwygType
	show_link?: boolean
	blue_bg?: boolean
}

export const TextBlock: FunctionComponent<TextBlockType> = ({
	text,
	show_link,
	blue_bg
}) => {
	if (!text) return
	return (
		<Block class={styles}>
			<Theme.Wysiwyg class={styles.mod({col: show_link, blue_bg})}>
				{text}
			</Theme.Wysiwyg>
			{show_link && <div class={styles.mod('col')}></div>}
		</Block>
	)
}
